export interface JwtPayload {
    [key: string]: any;
    iss?: string | undefined;
    sub?: string | undefined;
    aud?: string | string[] | undefined;
    exp?: number | undefined;
    nbf?: number | undefined;
    iat?: number | undefined;
    jti?: string | undefined;
}

export function parseJWT(token: string): JwtPayload {
    const payload: JwtPayload = JSON.parse(Buffer.from(token.split('.')[1], 'base64').toString());
    return payload;
}

export function isValidExpiry(payload: JwtPayload): boolean {
    const exp = payload.exp;
    const now = Math.round(new Date().getTime() / 1000);
    return exp > now;
}


export class MemoryUserCredentialsDataStorage {
    data: any;
    constructor() {
        this.data = {};
    }
    key(n: number) {
        return Object.keys(this.data)[n];
    }
    getItem(key: string) { return this.data[key] }
    setItem(key: string, value: string) { this.data[key] = value }
    removeItem(key: string) { this.data[key] = undefined }
    clear() { this.data = {} }
}
